import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { config } from '../../../../config';

const SocialProof = () => {
  const [socialProofs, setSocialProofs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const apiUrl = config.apiUrl;
  const { slug } = useParams();
 
  useEffect(() => {
    const fetchSocialProof = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${apiUrl}/socialproofs`);
        
        // Safely handle response data
        const proofsData = response?.data || [];
        console.log('Fetched social proofs:', proofsData);
        const filteredProofs = proofsData.filter(proof => proof?.slug === slug);
        console.log('Filtered social proofs:', filteredProofs);
        // Safely access social_proofs with null checks
        setSocialProofs(filteredProofs);
        
      } catch (err) {
        console.error('Error fetching social proof:', err);
        setError('Failed to load testimonials');
        setSocialProofs([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSocialProof();
  }, [slug, apiUrl]);

  if (loading) {
    return <div className="text-center py-4">Loading testimonials...</div>;
  }

  if (error) {
    return <div className="text-center text-red-500 py-4">{error}</div>;
  }

  return (
    <>
    {socialProofs.length > 0 && <div className="bg-white rounded-xl shadow-md p-6 mt-6">
      <h3 className="text-lg font-bold text-gray-800 mb-3">What Others Are Saying</h3>
      <div className="flex flex-col gap-4">
        {(
          socialProofs.map((proof, index) => (
            <div key={index} className="space-y-4">
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-600 italic">{proof?.description || 'Testimonial content'}</p>
                <p className="text-sm text-gray-500 mt-2">
                  - {proof?.name || 'Anonymous'}, {proof?.designation || 'Happy Customer'}
                </p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>}
    </>
  );
};

export default SocialProof;